/**
 * Prevent ExpressionChangedAfterItHasBeenCheckedError errors
 *
 * Note: This is at best a hack, but desperate times demand desperate measures... plus I'm a bad developer and don't actually know what's causing the issue...
 */
const changeDetection = (func: () => void, delay: number = 0) => {
  setTimeout(func, delay);
};

export { changeDetection };
